export const MODERATION_FIELD_STATUS = {
  MODERATION_FAILED: "validation_failed",
  // We will delete this after ive updated the mock response in mu2 as it seems this was missed
  MODERATION_FAILED_MOCK_TEMP: "validation-failed",
  ERROR: "error",
  OK: "ok",
  // TODO this doesn't appear in mu2 or mcs - double check and remove with the above
  NOT_CHANGED: "not-changed",
} as const;

export const MODERATION_RESPONSE_STATUS = {
  OK: "ok",
  NOT_FOUND: "not-found",
  ERROR: "error",
} as const;
